import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers/reducer';
import loginReducer from '../reducers/manufacturer_auth/loginReducer';
import quoteReducer from '../reducers/quote_order/quoteReducer';
import orderReducer from '../reducers/quote_order/orderReducer';
import eventReducer from '../reducers/common/eventReducer';
import componentReducer from '../reducers/building_component/componentReducer';
import leadcustomerReducer from '../reducers/quote_order/leadcustomerReducer';
import priceUpdateReducer from '../reducers/building_pricing/priceUpdateReducer';
import orderExtrasReducer from '../reducers/extra_options/extraoptionsReducer';
import screenShareReducer from '../reducers/share_screen/screenShareReducer';
const rootReducer = combineReducers({
    reducer,
    loginReducer,
    quoteReducer,
    orderReducer,
    orderExtrasReducer,
    priceUpdateReducer,
    leadcustomerReducer,
    eventReducer,
    componentReducer,
    screenShareReducer,
})
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
